import { render, staticRenderFns } from "./DocumentationPart.vue?vue&type=template&id=95cbe2fa"
import script from "./DocumentationPart.vue?vue&type=script&lang=js"
export * from "./DocumentationPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports